import { getCurrentInstance, getCurrentScope } from '@vue/composition-api'

export type UseContextResult = NonNullable<
  ReturnType<typeof getCurrentInstance>
>['proxy'] & {
  _: Record<string, any>
}

export function useContext(): UseContextResult {
  // https://github.com/vuejs/composition-api/blob/main/src/apis/effectScope.ts#L114
  const ctx =
    (getCurrentScope as any)()?.vm || (getCurrentInstance as any)()!.proxy

  return ctx
}
